const cParentActive = 'faq-accordion__item_active';
const sCont = '.faq-accordion__cont';
const sContent = '.faq-accordion__content';

$('.faq-accordion__item').on('click', function () {
    const $parent = $(this);

    if ($parent.length) {
        const $cont = $parent.find(sCont);
        const $content = $parent.find(sContent);

        if ($cont.length && $content.length) {
            if (!$parent.hasClass(cParentActive)) {
                $cont.css({ height: $content.outerHeight() });
            } else {
                $cont.removeAttr('style');
            }

            $parent.toggleClass(cParentActive);
        }
    }
});